import React, { useState, useCallback, useMemo } from "react";
import { updateBoard } from "../../../../../services/apiBoards";
import FormDialog from "../../../../../components/Dialog/FormDialog";
import { Typography } from "@mui/material";
import { useBoardMutationDialog } from "../../hooks/useBoardMutationDialog";

function Accessibility({ isPrivate = false, params }) {
  const [status, setStatus] = useState(isPrivate);
  const data = useMemo(() => ({ is_private: !isPrivate }), [isPrivate]);

  const boardVisibilityDialog = useBoardMutationDialog({
    apiFn: updateBoard,
    invalidateKeys: ["boards"],
    onSuccess: () => {
      setStatus((data) => !data);
    },
  });

  const submitBoardAccessibility = useCallback(() => {
    boardVisibilityDialog.submit({ board_id: params.row.board_id, data });
  }, [boardVisibilityDialog, data, params.row.board_id]);

  return (
    <>
      {boardVisibilityDialog.isDialogOpen && (
        <FormDialog
          open={boardVisibilityDialog.isDialogOpen}
          handleClose={boardVisibilityDialog.closeDialog}
          handleSubmit={submitBoardAccessibility}
          loading={boardVisibilityDialog.isSubmitting}
          buttonTxt={isPrivate ? "Public" : "Private"}
          title={"Change Board Visibility"}
          cancelBtn={true}
          alignActions={"center"}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            Are you sure to change the Board visibility?
          </Typography>
        </FormDialog>
      )}
      <div className="w-100 d-flex justify-content-center">
        <label className="custom-checkbox">
          <input
            type="checkbox"
            checked={status}
            onClick={boardVisibilityDialog.openDialog}
          />
          <span className="checkmark"></span>
        </label>
      </div>
    </>
  );
}

const isChangeAccessibility = (prevProps, nextProps) => {
  return (
    prevProps?.params?.row?.board_id === nextProps?.params?.row?.board_id
    && prevProps?.params?.row?.is_private === nextProps?.params?.row?.is_private
  );
};

export default React.memo(Accessibility, isChangeAccessibility);
